/**
 * See https://stackoverflow.com/a/30106551
 */

export function toBase64(str: string) {
	return btoa(
		encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
			return String.fromCharCode(parseInt(p1, 16));
		})
	);
}

export function fromBase64(str: string) {
	return decodeURIComponent(
		Array.prototype.map
			.call(atob(str), function (c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);
}
